module.exports = __webpack_public_path__ + "media/customizations/mylwr/logo-f68caff2c44f046447655c1180651e37.png";